import { render } from "./Candlestick.vue?vue&type=template&id=5897b0b0&scoped=true"
import script from "./Candlestick.vue?vue&type=script&lang=js"
export * from "./Candlestick.vue?vue&type=script&lang=js"

import "./Candlestick.vue?vue&type=style&index=0&id=5897b0b0&lang=scss&scoped=true"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5897b0b0"]])

export default __exports__